var lifeInsuranceSearch = function (type, birthday, birthmonth, birthyear, capacity, duration, method, job, c14) {
    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('life-field-error');
            setTimeout(function () {
                $target.removeClass('life-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    var url_param = '';
    url_param += '?';
        if (birthday.val() == 'NAN') {
            return showFieldError(birthday, 'لطفاً روز تولد را انتخاب کنید.');
        }
        if (birthmonth.val() == 'NAN') {
            return showFieldError(birthmonth, 'لطفاً ماه تولد را انتخاب کنید.');
        }
        if (birthyear.val() == 'NAN') {
            return showFieldError(birthyear, 'لطفاً سال تولد را انتخاب کنید.');
        }
        if (capacity.val() == '') {
            return showFieldError(capacity, 'لطفاً توان پرداخت ماهانه را وارد کنید.');
        }
        if (duration.val() == -1 || duration.val() == null || duration.find("option:selected").text() == "") {
            return showFieldError(duration, 'لطفاً مدت قرارداد را انتخاب کنید.');
        }
        if (method.val() == -1 || method.val() == null || method.find("option:selected").text() == "") {
            return showFieldError(method, 'لطفاً روش پرداخت را انتخاب کنید.');
        }

        var Birthday = birthday.val();
        var Birthmonth = birthmonth.val();
        var Birthyear = birthyear.val();
        var birthDate = Birthyear + '/' + Birthmonth + '/' + Birthday;
        var Capacity = capacity.val();
        // Capacity = Capacity.replace(/,/g, '');
        if(Capacity.replace(/,/g, '') < 50000){
            return showFieldError(capacity, 'حداقل مبلغ توان پرداخت ماهانه 50 هزار تومان است.');
        }
        var C14 = c14.val();
        // C14 = C14.replace(/,/g, '');

        var Duration = duration.val();
        var Method = method.val();
        var Job = job.val();

        url_param += '&birthday=' + birthDate;
        url_param += '&capacity=' + Capacity;
        url_param += '&duration=' + Duration;
        url_param += '&payMethod=' + Method;

        if(Job){
            url_param += '&job=' + Job;
        }

        if(C14){
            url_param += '&c14=' + C14;
        }

        window.location = lifeInsuranceSearchUrl + '/'  + url_param;
};

$(document).ready(function () {

    $('.life_insurance_searchBtn_top').click(function () {
        var type = $(this).data('type');
        var parent = '#flexibleLifeInsurance';

        var birthday = $(parent + ' #life_birth_day_select');
        var birthmonth = $(parent + ' #life_birth_month_select');
        var birthyear = $(parent + ' #life_birth_year_select');
        var capacity = $(parent + ' #life-payment-capacity-input');
        var duration = $(parent + ' #life_contract_duration_select');
        var method = $(parent + ' #life_pay_duration_method_select');
        var job = $(parent + ' #life-main-job-input');
        var c14 = $(parent + ' #life-c14-input');

        lifeInsuranceSearch(type, birthday, birthmonth, birthyear, capacity, duration, method, job, c14);

    });

});

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
